export default "__VITE_ASSET__kLsSsCuZ__"